<template>
  <div class="">
    <div
      v-for="(item, index) in dataList"
      @click="handlerClick(item)"
      :key="`moral-grade${index}`"
      class="bg-FFFFFF mb-20 m-0-16 p-12-0 p-0-16 h-70 fb fb-cross-center fb-main-between bd-radio-6"
    >
      <p
        class="item-flex-2 nowrap text-ellipsis hidden br-12 lh-46 font-30 ff-medium"
        >{{ item.deptName }}</p
      >
      <div class="item-flex-1 pl-16">
        <p class="font-24 c-171A1D-56 mb-4">表扬</p>
        <p class="font-36 c-006AFE ff-medium"
          >{{ +item.totalPraiseScore > 0 ? '+' : ''
          }}{{ item.totalPraiseScore }}</p
        >
      </div>
      <div class="item-flex-1 pl-16">
        <p class="font-24 c-171A1D-56 mb-4">待改进</p>
        <p class="font-36 c-171A1D-85 ff-medium">{{
          item.totalNeedImproveScore
        }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    dataList: {
      type: Array,
      default: () => {
        return []
      }
    },
    moralType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClick(item) {
      this.$emit('click', item)
    }
  }
}
</script>

<style lang="scss" scoped></style>
